import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";

import { RenderInputFields, SubmitButton, Input, CKEditorInput, SelectInput, SubTab, SubInput } from "../Form/Form";

import { compareChanges } from "../../util/fn";
import { CHANGES_REQ_MESSAGE } from "../../util/other";
import { useSelector } from "react-redux";

const Edit = (props) => {
  const { id: planId } = props.match.params;
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    getValues,
    reset,
    clearErrors,
    control,
    setError

  } = useForm();
  const ckEditorRef = useRef();
  const [ckcontent, setCkContent] = useState();
  const { languages } = useSelector((state) => state.setting);
  const { response: responseFetchPlan, request: requestFetchPlan } = useRequest();
  const { response: currencyResponse, request: currencyRequest } = useRequest()
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const { response, request } = useRequest();
  const [oldValues, setOldValues] = useState([]);

  useEffect(() => {
    if (planId) {
      requestFetchPlan("GET", `plan/${planId}`);
      document.title = "Edit Plan - Calevalab";
    }
  }, [planId]);

  useEffect(() => {
    ckEditorRef.current = {};
    if (languages) {
      languages.forEach((lang) => {
        register(`benifits-${lang.code}`, { required: true });
        ckEditorRef.current[lang.code] = null;
      });
    }
  }, [languages]);



  useEffect(() => {
    currencyRequest("GET", "currency/data")
  }, [])

  useEffect(() => {
    if (currencyResponse) {
      setCurrencies(currencyResponse.data)
    }
  }, [currencyResponse])

useEffect(() => {
  if (responseFetchPlan) {
    const { name, price, benifits, currencyCode, langData } = responseFetchPlan.plan;

    const langDataWithoutId = langData.map(({ _id: _, ...rest }) => rest);
    const langDataShortedOld = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));

    setOldValues({
      price,
      currency: currencyCode,
      langData: langDataShortedOld,
    });

    const formData = {
      name,
      price,
      benifits,
      currency: currencyCode,
    };

    if (langData?.length > 0) {
      langData.forEach((lang) => {
        const code = lang?.languageCode;
        formData[`name-${code}`] = lang?.name || "";
        formData[`benifits-${code}`] = lang?.benifits || "";
        formData[`id-${code}`] = lang?._id || "";
      });
    }

    reset(formData); 

    const initialCurrency = currencies?.find(cur => cur.code === currencyCode);
    setSelectedCurrency(initialCurrency);

    setCkContent(true);
  }
}, [responseFetchPlan, currencies]);



  useEffect(() => {
    if (response) {
      toast.success("Plan has been updated successfully.");
      history.push("/Plans");
    }
  }, [response]);




  const handleCurrencyChange = (e) => {
    const selectedCode = e;

    if (!selectedCode) return;

    const selectedCurrency = currencies?.find(
      (cur) => cur.code === selectedCode
    );

    if (selectedCurrency) {
      setSelectedCurrency(selectedCurrency)
    }
  };


  const onSubmit = async (data) => {
    const dataToSend = [], defaultData = {};
    const error = [];

    const latestValues = getValues();

    const currency_id = selectedCurrency?._id || null;
    const currency_sign = selectedCurrency?.sign || "";
    const currency_code = selectedCurrency?.code || "";

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      const name = data["name-" + code];
      const benifits = data["benifits-" + code];

      dataToSend.push({
        languageCode: code,
        name,
        benifits,
      });

      if (languages[i].default) {
        defaultData.name = name;
        defaultData.benifits = benifits;
      }

      if (!name || name.length === 0) {
        setError(`name-${code}`, { type: "manual" });
        error.push(true);
      }

      if (!benifits || benifits.length === 0) {
        setError(`benifits-${code}`, { type: "manual" });
        error.push(true);
      }
    }

    if (error.some(err => err)) return;

    const langDataShorted = dataToSend.sort((a, b) =>
      a.languageCode.localeCompare(b.languageCode)
    );

    const transformedData = {
      id: planId,
      name: defaultData.name,
      benifits: defaultData.benifits,
      price: latestValues.price,
      currency_id,
      currency_sign,
      currency_code,
      langData: langDataShorted
    };

    if (compareChanges(oldValues, transformedData)) {
      await request("PUT", "plan", transformedData);
    } else {
      toast.error(CHANGES_REQ_MESSAGE || "No changes detected.");
    }
  };



  const InputFields = [
    [
      {
        Component: SelectInput,
        label: "Currency",
        name: "currency",
        registerFields: {
          required: true,
        },
        handleChange: (e) => handleCurrencyChange(e),
        defaultValue: responseFetchPlan?.plan?.currencyCode, // Add this
        control: control,
        children: [
          { value: "", label: "Select Currency" },
          ...(currencies || []).map((cur) => ({
            value: cur.code,
            label: `${cur?.name}${cur?.sign ? ` (${cur.sign})` : ""}`,
          })),
        ],
      },
      {
        Component: Input,
        label: "Price",
        type: "text",
        name: "price",
        registerFields: {
          required: true,
          pattern: /^[0-9]+(\.[0-9]+)?$/,
        },
        registerFieldsFeedback: {
          pattern: "Price can only contains numbers.",
        },
      },

    ],
  ];

  return (
    <div className="content  d-flex flex-column flex-column-fluid" id="kt_content">
      <Breadcrumb
        title="Edit Plan"
        links={[
          { to: "/", name: "Dashboard" },
          {
            to: { pathname: "/plans" },
            name: "Back To Plans",
          },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">Edit Plan</h3>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                        <div className="card-body px-0">
                          <div className="tab-content px-10">
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <>
                                  <SubInput
                                    key={index}
                                    index={index}
                                    errors={errors}
                                    register={register}
                                    required={true}
                                    InputFields={[
                                      [
                                        {
                                          Component: Input,
                                          type: "text",
                                          label: "Name",
                                          name: "name",
                                          colClass: "col-lg-12",
                                          registerFields: {
                                            required: true,
                                          },
                                        },
                                      ],
                                      [{
                                        Component: CKEditorInput,
                                        colClass: "col-xl-12",
                                        label: "Benifits",
                                        name: "benifits",
                                        registerFields: {
                                          required: false,
                                        },
                                        getValues,
                                        setValue,
                                        trigger,
                                        otherRegisterFields: {
                                          manual: true,
                                          feedback: "Benifits is required",
                                        },
                                        inputData: {
                                          onInstanceReady: (editor) => {
                                            ckEditorRef.current[lang.code] = editor;
                                          },
                                        },
                                        clearErrors,
                                        isEdit: true,
                                        ckcontent: ckcontent
                                      },]
                                    ]}
                                    code={lang.code}
                                  />
                                </>
                              ))}
                          </div>
                          <div className="row"></div>
                        </div>
                      </div>
                    </div>
                    <RenderInputFields InputFields={InputFields} errors={errors} register={register} />

                    <div className="row"></div>

                    <SubmitButton handleSubmit={handleSubmit} onSubmit={onSubmit} name="Update" />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;